import { Checkbox, Col, Row, Table, Tooltip, Typography } from "antd";
import { DataDomainChangedAttributes } from "components";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import _ from "lodash";
import moment from "moment";
import { useState } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;
const { Link } = Typography;

const BusinessAreaDataHistoryList = ({ dataDomainRevisions }) => {
    const [recordDetail, setRecordDetail] = useState(null);

    return (
        <FlexContainerLayout contentClassName="gap-4">
            <FlexContainerLayout>
                <Table
                    size="small"
                    data-testid={CypressTestIds.COMMON_OBJECTS_REVISIONS_LIST_TABLE}
                    rowKey="metadata.txId"
                    dataSource={dataDomainRevisions}
                    pagination={false}
                    className="flex size-full flex-1 flex-col [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10 [&_thead]:bg-header-footer [&_thead]:text-header-footer"
                >
                    <Column width="3rem" title="No." key="index" render={(value, item, index) => index + 1} />
                    <Column width="12rem" dataIndex={["data", "businessAreaName"]} title={"Business Area"} render={(value, revision, index) => <>{value || "Global"}</>} />
                    <Column width="10rem" dataIndex={["data", "domainName"]} title={"Domain"} render={(value, revision, index) => <>{value}</>} />
                    <Column
                        width="12rem"
                        dataIndex={["data", "domainDescription"]}
                        title={"Domain Description"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, revision, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="12rem"
                        dataIndex={["data", "domainPurpose"]}
                        title={"Domain Purpose"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, revision, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="10rem"
                        dataIndex={["data", "usedForTagging"]}
                        title={"Used for tagging"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, revision, index) => {
                            return <Checkbox checked={value} onChange={(e) => ({})}></Checkbox>;
                        }}
                    />
                    <Column
                        width="15rem"
                        dataIndex={["data", "createdByEmail"]}
                        title={"Created By"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, revision, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="12rem"
                        dataIndex={["data", "createdDate"]}
                        title={"Created Date"}
                        render={(value, revision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                    />
                    <Column
                        width="15rem"
                        dataIndex={["data", "updatedByEmail"]}
                        title={"Updated By"}
                        ellipsis={{
                            showTitle: false,
                        }}
                        render={(value, revision, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        )}
                    />
                    <Column
                        width="12rem"
                        dataIndex={["data", "updatedDate"]}
                        title={"Updated Date"}
                        render={(value, revision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                    />
                    <Column
                        width="12rem"
                        dataIndex={"changes"}
                        title={"Changes"}
                        render={(value, revision, index) => {
                            if (value) {
                                return (
                                    <>
                                        {Object.keys(value).reduce((items, key) => {
                                            if (Object.keys(value[key]).length > 0) {
                                                items.push(
                                                    <Row key={key}>
                                                        <Col>
                                                            <Link
                                                                onClick={() => {
                                                                    setRecordDetail({
                                                                        name: `${_.capitalize(key)} attributes`,
                                                                        recordId: revision.data.dataDomainId,
                                                                        data: value[key],
                                                                        previousData: revision.previousChanges && revision.previousChanges[key],
                                                                    });
                                                                }}
                                                            >
                                                                {`${key} attributes`}
                                                            </Link>
                                                        </Col>
                                                    </Row>,
                                                );
                                            }
                                            return items;
                                        }, [])}
                                    </>
                                );
                            }
                            return <></>;
                        }}
                    />
                </Table>
            </FlexContainerLayout>
            {recordDetail ? (
                <FlexContainerLayout>
                    <DataDomainChangedAttributes key={recordDetail.recordId} record={recordDetail}></DataDomainChangedAttributes>
                </FlexContainerLayout>
            ) : (
                <></>
            )}
        </FlexContainerLayout>
    );
};

export default BusinessAreaDataHistoryList;
